import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class StatusRelatorioAcompanhamento extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/StatusRelatorioAcompanhamentoLookup" {...this.props} />;
  }
}

export default StatusRelatorioAcompanhamento;
